import { render } from "./Accoglienza.vue?vue&type=template&id=5e40fd77"
import script from "./Accoglienza.vue?vue&type=script&lang=js"
export * from "./Accoglienza.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\fr201\\Informatique\\annuario\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__